export const VERSION_FRONT = '1.0.0';

// Desarrollo
//export const URL_SERVICIOS = 'http://localhost:81/inamu/';
//export const URL_SERVICIOS = location.origin + '/inamu/';
//export const URL_SERVICIOS = 'https://inamu.avatarsys.io/avatar/';
//export const URL_SERVICIOS = 'https://migra-cuc.avatarsys.io/avatar_pruebas/';
//export const URL_SERVICIOS =   "https://soydev.ulatina.edu.pa" + '/pruebas/';
export const URL_SERVICIOS =   location.origin + '/avatar/';
//export const URL_SERVICIOS =   location.origin + '/pruebas/';
//export const URL_SERVICIOS =   location.origin + '/avatar_soydev3/';
//export const URL_SERVICIOS =   location.origin + '/avatar23OCT2026/';
//export const URL_SERVICIOS = 'https://migra-cuc.avatarsys.io/demos2026/';
//export const URL_SERVICIOS = 'https://migra-cuc.avatarsys.io/avatar20MAR2026/';


// URL ARCHIVOS PUBLICOS
//export const URL_AVATAR = 'http://localhost:81/inamu/uploads/';
//export const URL_AVATAR = location.origin + '/inamu/uploads/';
//export const URL_AVATAR = 'https://inamu.avatarsys.io/avatar/uploads/';
//export const URL_AVATAR = 'https://migra-cuc.avatarsys.io/avatar_pruebas/uploads/';
//export const URL_AVATAR =    "https://soydev.ulatina.edu.pa" + '/pruebas/uploads/';
export const URL_AVATAR =    location.origin + '/avatar/uploads/';
//export const URL_AVATAR =    location.origin + '/pruebas/uploads/';
//export const URL_AVATAR =    location.origin + '/avatar_soydev3/uploads/';
//export const URL_AVATAR =    location.origin + '/avatar23OCT2026/uploads/';
//export const URL_AVATAR =    "https://migra-cuc.avatarsys.io" + '/demos2026/uploads/';
//export const URL_AVATAR =    "https://migra-cuc.avatarsys.io" + '/avatar20MAR2026/uploads/';

// CONFIG NUEVA CASTRO CARAZO
// export const URL_SERVICIOS = '/avatar_pruebas/';
// export const URL_AVATAR =    "/avatar_pruebas" + '/uploads/';

//INAMU
/*
export const PARAMETROS_CLIENTE = {
    logo : "logoinamu.png",
    nombreSistema: "SIPGAF",
    descripcionSistema: "Sistema Integrado de Planificación, Gestión Financiera y Recursos Humanos \"SIPGAF\""
}*/

/*
//CUC
export const PARAMETROS_CLIENTE = {
    logo : "logocunlimon.png",
    nombreSistema: "",
    descripcionSistema: ""
}*/

//GENERAL
export const PARAMETROS_CLIENTE = {
    logo : "Logo.png",
    nombreSistema: "Sistema AVATAR",
    descripcionSistema: "Sistema AVATAR"
}